import Select from '@material-ui/core/Select';

export default Select;
